import { Button } from '@/components/ui/button'
import { Plus, CheckSquare } from 'lucide-react'

interface QuickActionsProps {
  onAddLead: () => void
  onCreateTask: () => void
}

export function QuickActions({ onAddLead, onCreateTask }: QuickActionsProps) {
  return (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-slate-900">Ações Rápidas</h3>
      <div className="flex flex-wrap gap-4">
        <Button onClick={onAddLead} className="shadow-sm">
          <Plus className="mr-2 h-4 w-4" />
          Adicionar Lead
        </Button>
        <Button
          onClick={onCreateTask}
          variant="secondary"
          className="shadow-sm bg-white hover:bg-slate-50 border border-slate-200"
        >
          <CheckSquare className="mr-2 h-4 w-4 text-slate-600" />
          Criar Tarefa
        </Button>
      </div>
    </div>
  )
}
